import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Form, Formik } from "formik";
import {
  getPostInitialValues,
  VALIDATION_SCHEMA,
} from "web/components/utils/commentModalUtils";
import { postAdminCommentV2} from "redux/actions/admin";
import styled from "styled-components";
import TextArea from 'web/components/form-elements/TextArea';
import AlertModal from "web/components/AlertModal";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { storeAdminDetails, logoutAdmin } from "redux/actions/admin";

function SetupCommissionModal({
  toggle,
  tabValue,
  editResponse,
  editFlag,
}) {
  const dispatch = useDispatch();
  let history = useHistory();
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState("");

  const [alertType, setAlertType] = useState();

  const addComment = async (props) => {
    let data={
      postId:editResponse?.postId,
      postType:tabValue===0?"NEED":"INVENTORY",
      postCommentByAdmin:{
        msg:props.values?.comment,
        commentBy:localStorage.getItem('adminName')
      }
    }
    const token = localStorage.getItem("token");
    let response = await dispatch(postAdminCommentV2(data, token));

    if (response && response?.success) {
      setAlertModalContent(response?.data?.msg || response?.message);
      setAlertModal(!alertModal);
      setAlertType("success");
    } else {
      if (response.statusCode === 401) {
        adminLogout();
      } else {
        setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setAlertModal(true);
      }
    }
  };

  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}));
    dispatch(logoutAdmin());
    localStorage.removeItem("adminRolesData");
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("token");
    history.push("./sign-in");
    window.location.reload(false);
  };

  return (
    <>
      <div>
        <div className="modal-header-style">
          <h6>Comment</h6>
          <img
            src={CloseIcon}
            alt="close-icon"
            onClick={() => {
              toggle();
            }}
          />
        </div>

        <Formik
          initialValues={getPostInitialValues(editResponse, editFlag)}
          validationSchema={VALIDATION_SCHEMA()}
          onSubmit={(values) => {}}
        >
          {(props) => {
            const { isValid, dirty } = props;

            return (
              <Form>
                <div
                  style={{ padding: "25px 25px 0px", "padding-bottom": "0px" }}
                >
                  <InputFieldsWrapper>
                      <div className="row">
                        <div className="col-md-12 mb-4">
                          <TextArea
                              name='comment'
                              maxLength='200'
                              showErrorMessages={true}
                          />
                        </div>
                      </div>
                  </InputFieldsWrapper>
                </div>

                <InputFieldsWrapper>
                  <div
                    className="submitBtn"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      "margin-bottom": "20px",
                    }}
                  >
                    <button
                      className="green-button"                     
                      onClick={() => {
                        toggle();
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className="green-button"
                      disabled={!(isValid && dirty)}
                      onClick={() => {
                        if (editFlag) {
                          // updateCommission(commissionList, props);
                        } else {
                          addComment(props);
                        }
                      }}
                    >
                      {editFlag ? "Update" : "Submit"}
                    </button>
                  </div>
                </InputFieldsWrapper>
              </Form>
            );
          }}
        </Formik>
      </div>
      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType={alertType}
        callBackAlert={(val) => {
          if (val === "success") {
            toggle();
          }
        }}
      />
    </>
  );
}

export default SetupCommissionModal;

const InputFieldsWrapper = styled.div`
  .css-os3nnz-control {
    border: none;
  }
  .app-input-text {
    font-size: 15px;
  }
  .css-1lmoifu-control {
    background-color: #fff !important;
    border-color: #fff !important;
    border-bottom: 1px solid rgb(225, 225, 225) !important;
  }
  .modal-date-picker-style {
    .file-input-wrapper .MuiFormControl-root {
      height: 37px;
      border: none;
      border-bottom: 1px solid rgb(225, 225, 225) !important;
    }
    .file-input-wrapper .MuiFormControl-root .MuiInput-root {
      height: 100%;
      padding: 2px 0;
      input {
        border: none !important;
      }
    }
  }
  .select-wrapper-style {
    /* margin-bottom: 30px; */
    .react-select__control {
      border-radius: 0;
      border-bottom: 1px solid rgb(225, 225, 225) !important;
    }
    .react-select__value-container {
      padding: 0;
    }
    .react-select__input {
      input {
        border: none !important;
      }
    }
  }
  h5 {
    color: #ababab;
    font-size: 11px;
    margin-bottom: 3px;
  }
  h4 {
    text-align: center;
    font-weight: bold;
    font-size: 26px;
  }
  h5 {
    /* text-align: center; */
    font-size: 14px;
    margin: 17px 0 0 0px;
    max-width: 370px;
  }
  p {
    color: #ef5657;
    font-size: 11px;
    margin-top: 2px;
  }
  img {
    top: 4px !important;
    left: 6px !important;
    width: 20px;
    height: 20px;
  }
  input {
    border: none;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 0;
    padding: 0;
    border-top: none;
    border-right: none;
    border-left: none;
    border-image: initial;
    border-bottom: 1px solid rgb(225, 225, 225) !important;
    border-radius: 0px;
    padding: 0px;
  }

  .flatType {
    input:disabled {
      background-color: hsl(0, 0%, 95%) !important;
    }
  }
  .fixed-height {
    position: relative;
    min-height: 72px;
    .height-adjust {
      position: absolute;
      top: 15px;
      width: 90%;
    }
  }
  .date-style {
    border: 1px solid #87cdf1 !important;
    border-radius: 2px !important;
    padding: 0px 20px 0 15px !important;
  }
  .green-button {
    background: linear-gradient(90deg, #55c416 1.12%, #367910 100%);
    border: none;
    border-radius: 5px;
    height: 30px;
    color: #fff;
    font-size: 14px;
    margin-right: 15px;
  }
  .bordered-input {
    input {
      border: 1px solid #87cdf1;
      border-radius: 5px;
      padding: 0px 10px 0px 10px;
    }
  }
  .date-border-adjust {
    input {
      border: none;
      /* padding: 5px; */
    }
  }
  .error-styling-input {
    input {
      border: none !important;
      border-bottom: 1px solid #ef5657 !important;
    }
  }
  .table thead th,
  .table td,
  .table th {
    font-size: 14px;
  }
  .userlist-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 0 15px 0;
    h1 {
      font-size: 16px;
      font-weight: bold;
    }
    img {
      cursor: pointer;
    }
  }
  .app-input-text {
    margin-bottom: 15px !important;
  }
  .app-input-text input.error {
    border: none !important;
    border-bottom: 1px solid #ef5657 !important;
  }
  .radio-checkmark {
    top: 2.5px !important;
    border: 1px solid #005586 !important;
  }
  .radio-checkmark:after {
    background: #005586 !important;
  }
  .radioField {
    span {
      font-size: 14px;
    }
  }
  .checkbox-field {
    margin: 0 0 0 14px !important;
  }
  .checkbox-container {
    font-size: 14px !important;
  }
  .checkMark {
    border: solid 2px #d5d5d5 !important;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkMark {
    background: linear-gradient(to bottom, #f7f9fa 0%, #f7f9fa 100%) !important;
  }
  .checkbox-container input:checked ~ .checkMarkDisable:after {
    display: block;
  }
  .checkbox-container .checkMarkDisable:after {
    left: 6px;
    top: 2px;
    width: 6px;
    height: 11px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }

  .checkMarkDisable:after {
    content: "";
    position: absolute;
    display: none;
  }
  .checkbox-container input:checked ~ .checkMarkDisable {
    position: absolute;
    top: 0;
    left: 0;
    background-color: transparent;
    border-radius: 2px;
    border: solid 2px #979797;
    height: 21px;
    width: 21px;
    background: linear-gradient(to bottom, #979797 0%, #979797 100%);
  }

  .checkMarkDisable:after {
    border: solid black !important;
    border-width: 0 3px 3px 0 !important;
  }
  /* Style the checkMark/indicator */
  .checkMark:after {
    border: solid black !important;
    border-width: 0 3px 3px 0 !important;
  }

  .input-disabled {
    .app-input-text {
      input {
        background: #f2f2f2;
      }
    }
  }
  .submitBtn button:disabled {
    background: linear-gradient(90deg, #979797 1.12%, #979797 100%) !important;
    color: -internal-light-dark(
      rgba(16, 16, 16, 0.3),
      rgba(255, 255, 255, 0.3)
    ) !important;
    border-color: -internal-light-dark(
      rgba(118, 118, 118, 0.3),
      rgba(195, 195, 195, 0.3)
    ) !important;
  }
  .completion-page {
    height: 435px;
    padding: 90px 0 100px 0;
    text-align: center;
    img {
      width: 55px;
      height: 55px;
      margin: 20px;
    }
    .save-button {
      background: #005586;
      padding: 5px;
      width: 68px;
      border-radius: 5px;
      color: #fff;
      border: none;
    }
  }

  input:disabled {
    opacity: 0.5;
  }
`;
